// 유틸 함수: 분을 시간 비율로 변환 (0~59분 → 0~0.91)
export const convertMinuteToRatio = (minute) => {
  if (minute >= 55) {
    return 0.91;
  }
  else if (minute >= 50) {
    return 0.83;
  }
  else if (minute >= 45) {
    return 0.75;
  }
  else if (minute >= 40) {
    return 0.66;
  }
  else if (minute >= 35) {
    return 0.58;
  }
  else if (minute >= 30) {
    return 0.5;
  }
  else if (minute >= 25) {
    return 0.41;
  }
  else if (minute >= 20) {
    return 0.33;
  }
  else if (minute >= 15) {
    return 0.25;
  }
  else if (minute >= 10) {
    return 0.16;
  }
  else if (minute >= 5) {
    return 0.08;
  }
  else {
    return 0;
  }
};

// 유틸 함수: 시간 문자열을 시간 값으로 변환 (예: "09:30" → 9.5)
export const parseTimeToValue = (timeString) => {
  const [hour, minute] = timeString.split(':').map(Number);

  return hour + convertMinuteToRatio(minute);
};

// 유틸 함수: classTime에서 시작/종료 시간 값 추출
export const parseClassTimeRange = (classTime) => {
  const [startTime, endTime] = classTime.split('-');

  return {
    startValue: parseTimeToValue(startTime),
    endValue: parseTimeToValue(endTime)
  };
};
